"use client";

import { Link } from "@/components/common/Link";
export default function Hero() {
  return <section data-section-id="1400" id="porozmawiajmy-o-twoim-dachu" className="dark bg-background text-foreground min-h-screen relative overflow-hidden">
      <div className="grid grid-cols-1 lg:grid-cols-12 min-h-screen">
        {}
        

        {}
        <div className="lg:col-span-12 flex flex-col justify-center lg:px-[5vw] px-6 lg:py-16 py-12 relative" style={{
        width: "auto"
      }}>
          {}
          <div className="flex items-center gap-4 mb-12">
            <span className="font-mono text-[12px] tracking-[0.22em] uppercase" style={{
            color: "hsl(200 95% 45%)"
          }}>
              § HR-01 / TECH
            </span>
            <span className="h-px w-10 hidden lg:block" style={{
            backgroundColor: "hsl(200 95% 45%)"
          }} />
          </div>

          {}
          <h1 className="font-default font-bold text-foreground" style={{
          fontSize: "clamp(3.5rem, 8.2vw, 8.75rem)",
          letterSpacing: "-0.025em",
          lineHeight: "0.95"
        }}>
            <span className="block"><span className="!text-8xl">Trwała</span></span>
            <span className="block"><span className="!text-8xl">ochrona</span></span>
            <span className="block"><span className="!text-8xl">Twojego</span> <span className="italic" style={{
              color: 'rgb(6, 151, 224)'
            }} zn_id="875" contenteditable="false"><span className="!text-8xl">dachu</span></span></span>
          </h1>

          {}
          <div className="flex items-center mt-12 mb-8">
            <span className="h-px w-[120px] block" style={{
            backgroundColor: "hsl(200 95% 45%)"
          }} />
            <span className="ml-2 inline-block w-1.5 h-1.5 rounded-lg" style={{
            backgroundColor: "hsl(200 95% 45%)"
          }} aria-hidden="true" />
          </div>

          {}
          <p className="font-default text-muted-foreground max-w-md" style={{
          fontSize: "clamp(0.9375rem, 1.05vw, 1.0625rem)",
          lineHeight: "1.65",
          letterSpacing: "0.005em"
        }}>
            Profesjonalna hydroizolacja i renowacja dachów metodą natryskową. Bezspoinowe powłoki dla domów i przemysłu.
          </p>

          {}
          <div className="mt-16">
            <Link to="/ContactPage" className="inline-flex items-center gap-2 font-default text-[15px] tracking-[0.005em] underline underline-offset-[6px] decoration-1 hover:decoration-2 transition-all duration-200" style={{
            color: "hsl(200 95% 45%)"
          }}>
              Bezpłatna wycena →
            </Link>
          </div>

          {}
          <div className="lg:hidden mt-16 font-mono text-[11px] tracking-[0.18em] uppercase text-muted-foreground">
          </div>
        </div>
      </div>
    </section>;
}